import React, { FC } from 'react';
import { Breadcrumbs, Button, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MaterialSymbol } from '@/components/MaterialSymbol';
import Container from '../../../../components/Container';
import Styles from '../../../../assets/js/Styles';
import DeleteButton from '../../../../components/DeleteButton';
import { usePageEditorContext } from '../../PageEditorContext';
import { OutlinedContainer } from '../../../../components/OutlinedContainer';

interface PageListPageTreeSettingsProps {
  searchPathPageId?: number;
  setSearchPathPageId?: (v: number | null) => void;
  searchLevel?: 'siblings' | 'children';
  setSearchLevel?: (v: string) => void;
  openPageFinder: () => void;
  currentPageId?: number;
  startPageId?: number;
}

export const PageListPageTreeSettings: FC<PageListPageTreeSettingsProps> = ({
  searchPathPageId,
  setSearchPathPageId,
  searchLevel,
  setSearchLevel,
  openPageFinder,
  currentPageId,
  startPageId,
}) => {
  const { t: tComp } = useTranslation('components');
  const { selectionState, pages } = usePageEditorContext();

  return (
    <>
      <OutlinedContainer
        label={tComp('PageListAutoBlock.SearchPath.Label')}
        fullWidth
        wrap
        sx={{
          backgroundColor: '#fff',
        }}>
        <Container fullWidth spaceBetween>
          <Container wrap gap={1} left>
            <Breadcrumbs
              aria-label={tComp('components.EditorBreadcrumbs.Description')}
              separator={<MaterialSymbol name='chevron_right' />}>
              {searchPathPageId &&
                selectionState?.getParents(searchPathPageId)?.map((breadcrumb) => (
                  <Typography key={breadcrumb.id} variant='body2' color='text.secondary'>
                    {breadcrumb.title}
                  </Typography>
                ))}
              <Typography color='text.primary' sx={{ fontWeight: 'bold', textDecoration: 'none' }}>
                {pages?.find((value) => value.id === searchPathPageId)?.title}
              </Typography>
            </Breadcrumbs>
            {!searchPathPageId && (
              <Typography sx={{ color: Styles.Colors.MEDIUM_GREY }}>
                {tComp('PageListAutoBlock.SearchPath.NoSelection')}
              </Typography>
            )}
          </Container>
          <Container gap={1} right>
            <Button onClick={openPageFinder}>
              <MaterialSymbol name='edit' style={{ marginRight: '5px' }} />
              {tComp('PageListAutoBlock.ChoosePage')}
            </Button>
            {currentPageId !== undefined && currentPageId !== searchPathPageId && (
              <Button onClick={() => setSearchPathPageId?.(currentPageId ?? null)}>
                <MaterialSymbol name='edit' style={{ marginRight: '5px' }} />
                {tComp('PageListAutoBlock.ChoosePageCurrentPage')}
              </Button>
            )}

            {/* <DeleteButton onConfirm={() => setSearchPathPageId?.(null)} /> */}
          </Container>
        </Container>
      </OutlinedContainer>
      <Container fullWidth left column gap={4}>
        <FormControl>
          <RadioGroup
            value={searchLevel}
            defaultValue='children'
            onChange={(e) => setSearchLevel?.(e.target.value || 'children')}
            row>
            <FormControlLabel
              value='children'
              control={<Radio color='secondary' />}
              label={`${tComp('PageListAutoBlock.SearchLevel.children')} (${
                searchPathPageId ? selectionState?.getChildren(searchPathPageId)?.length : '-'
              })`}
            />
            {searchPathPageId !== startPageId && (
              <FormControlLabel
                value='siblings'
                control={<Radio color='secondary' />}
                label={`${tComp('PageListAutoBlock.SearchLevel.siblings')} (${
                  searchPathPageId ? selectionState?.getSiblings(searchPathPageId)?.length : '-'
                })`}
              />
            )}
          </RadioGroup>
        </FormControl>
      </Container>
    </>
  );
};

export default PageListPageTreeSettings;
